import { Injectable } from '@angular/core';
import { AppConfig } from '../app.config';

@Injectable({
  providedIn: 'root'
})
/** Service to request new access tokens using a refresh token. */
export class RefreshTokenService {

  constructor(private appConfig:AppConfig) { }

  async requestAccessTokenWithRefreshToken(refreshToken: string, clientId: string): Promise<any> {
    const tokenEndpoint = this.appConfig.idpTokenEndpoint;
    const body = new URLSearchParams({
      grant_type: 'refresh_token',
      refresh_token: refreshToken,
      client_id: clientId
    });

    const response = await fetch(tokenEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString()
    });


    if (!response.ok) {
      const errorBody = await response.text();
      throw new Error('Failed to refresh token: ' + errorBody);
    }
    const result = await response.json();
    return result;
  }
}
